import Turnstile from "react-turnstile";
import ContactFormFields from "@/components/landing/contact/ContactFormFields";
import ContactSubmitButton from "@/components/landing/contact/ContactSubmitButton";
import { useContactForm } from "@/components/landing/contact/useContactForm";
import { useLanguage } from "@/context/LanguageContext";

const ContactForm = () => {
  const { copy } = useLanguage();
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  const {
    formData,
    status,
    errorMessage,
    handleChange,
    handleSubmit,
    turnstileRef,
    handleTurnstileVerify,
    handleTurnstileExpire,
    handleTurnstileError,
  } = useContactForm();
  const isSubmitting = status === "sending";
  const isSuccess = status === "success";
  const isError = status === "error";

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
      <ContactFormFields formData={formData} onChange={handleChange} />
      {siteKey ? (
        <div className="contact-captcha" data-testid="contact-captcha">
          <Turnstile
            ref={turnstileRef}
            sitekey={siteKey}
            onVerify={handleTurnstileVerify}
            onExpire={handleTurnstileExpire}
            onError={handleTurnstileError}
          />
        </div>
      ) : (
        <p className="contact-status error" data-testid="contact-captcha-missing">
          {copy.contact.formCaptchaMissing}
        </p>
      )}
      {isSuccess ? (
        <p className="contact-status success" data-testid="contact-form-success">
          {copy.contact.formSuccess}
        </p>
      ) : null}
      {isError ? (
        <p className="contact-status error" data-testid="contact-form-error">
          {errorMessage || copy.contact.formError}
        </p>
      ) : null}
      <ContactSubmitButton isSubmitting={isSubmitting} />
    </form>
  );
};

export default ContactForm;
